import { useContext } from "react";

import Context from "./SessionContext";

const useSessionContext = () => useContext(Context);

export default useSessionContext;
